var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM13.4118 8.16667H18C18.4602 8.16667 18.8333 8.53977 18.8333 9V13.5942C18.8333 14.0544 18.4602 14.4275 18 14.4275C17.5398 14.4275 17.1667 14.0544 17.1667 13.5942V11.0227L14.0348 14.1784L14.0333 14.18C13.2918 14.9324 12.0852 14.9319 11.3444 14.1784L9.66013 12.4654C9.57531 12.3791 9.44531 12.3758 9.35699 12.4554L6.62482 15.5514C6.32029 15.8965 5.79368 15.9293 5.44861 15.6248C5.10353 15.3203 5.07066 14.7937 5.37518 14.4486L8.14238 11.3129L8.15812 11.2969C8.89943 10.5429 10.1073 10.5429 10.8486 11.2969L12.5328 13.0099C12.621 13.0997 12.7581 13.0997 12.8464 13.0099L12.8491 13.0072L15.9989 9.83333H13.4118C12.9515 9.83333 12.5784 9.46023 12.5784 9C12.5784 8.53977 12.9515 8.16667 13.4118 8.16667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsUp);
export default __webpack_public_path__ + "static/media/stats-up.ed2bcc5176f919434df87d5eafa72fdc.svg";
export { ForwardRef as ReactComponent };